/**
 * Generates a Shopify CDN URL for a given file name...
 * @param fileName
 * @returns
 */
export const shopifyCDNFile = (fileName: string | undefined): string => {
  if (!fileName) return '';
  // Ignore shopify CDN for images starting with a slash.
  if (fileName && fileName.slice(0, 1) === '/') return fileName;
  if (fileName && fileName.slice(0, 4) === 'http') return fileName;
  const shopifyShopId = process.env['REACT_APP_SHOPIFY_SHOP_ID'] || '56920277158';
  const shopifyPaddedId = shopifyShopId.toString().padStart(12, '0');
  const shopPath = shopifyPaddedId.substr(0, 4) + '/' + shopifyPaddedId.substr(4, 4) + '/' + shopifyPaddedId.substr(8, 4);
  return `https://cdn.shopify.com/s/files/1/${shopPath}/files/` + fileName;
};

/**
 * Generates the image src for a resized image with maximum dimensions `maxWidth` and `maxHeight`.
 * Images do not scale up.
 *
 * @memberof ImageHelpers
 * @method imageForSize
 * @param {Object} image The original image model to generate the image src for.
 * @param {Integer} maxWidth The maximum width for the image.
 * @param {Integer} maxHeight The maximum height for the image.
 * @return {String} The image src for the resized image.
 */
export const shopifyImageForSize = (imageURL: string, maxWidth: number, maxHeight: number | string = '', progressive: boolean = true) => {
  if (!imageURL.includes('cdn.shopify')) return imageURL;
  const splitUrl = imageURL.split('?');
  const notQuery = splitUrl[0];
  const query = splitUrl[1] ? `?${splitUrl[1]}` : '';

  // Use the section before the query
  const imageTokens = notQuery.split('.');

  // Take the token before the file extension and append the dimensions
  const imagePathIndex = imageTokens.length - 2;
  const devicePixelRatio = window.devicePixelRatio && window.devicePixelRatio > 1 ? '@2x' : '';

  imageTokens[imagePathIndex] = `${imageTokens[imagePathIndex]}_${maxWidth}x${maxHeight}${devicePixelRatio}${progressive ? '.progressive' : ''}`;

  return `${imageTokens.join('.')}${query}`;
};
